export default "__VITE_ASSET__Dqb635zK__"